import { useArtifactPanelStore } from '@/stores/artifactPanelStore.js';
import { EmptyState } from './EmptyState.js';
import { NoteArtifact } from '../NoteArtifact.js';
import { NotesListArtifact } from '../NotesListArtifact.js';
import { BrowserArtifact } from '../BrowserArtifact.js';

export function ContentArea() {
  const activeTabId = useArtifactPanelStore((state) => state.activeTabId);
  const artifacts = useArtifactPanelStore((state) => state.artifacts);

  if (!activeTabId) {
    return <EmptyState />;
  }

  const artifact = artifacts[activeTabId];

  if (!artifact) {
    return <EmptyState />;
  }

  // Render the appropriate artifact viewer based on type
  switch (artifact.type) {
    case 'note':
      return <NoteArtifact tabId={activeTabId} />;
    case 'notes-list':
      return <NotesListArtifact />;
    case 'browser':
      return <BrowserArtifact tabId={activeTabId} />;
    case 'file':
      return (
        <div className="flex h-full items-center justify-center text-muted-foreground">
          <div className="text-center">
            <p className="text-lg font-medium mb-2">File Viewer</p>
            <p className="text-sm">Coming soon...</p>
          </div>
        </div>
      );
    case 'image':
      return (
        <div className="flex h-full items-center justify-center text-muted-foreground">
          <div className="text-center">
            <p className="text-lg font-medium mb-2">Image Viewer</p>
            <p className="text-sm">Coming soon...</p>
          </div>
        </div>
      );
    case 'code':
      return (
        <div className="flex h-full items-center justify-center text-muted-foreground">
          <div className="text-center">
            <p className="text-lg font-medium mb-2">Code Viewer</p>
            <p className="text-sm">Coming soon...</p>
          </div>
        </div>
      );
    default:
      return <EmptyState />;
  }
}
